// extracted by mini-css-extract-plugin
export default {"dropdown":"style_dropdown__7DYes","avatar":"style_avatar__tb85Q"};